import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import BingMap from './BingMap';
import { getLat, getLng, saveLatLng } from '../duck';
import withProductCustomisation from '../../../../hocs/withProductCustomisation';
import { updateActiveCanvasDrawer } from '../../../CanvasDrawers/duck';
import withQueryParams from '../../../../hocs/withQueryParams';

const enhance = compose(
  connect(
    state => ({
      lat: getLat(state),
      lng: getLng(state),
    }),
    dispatch => ({
      saveLatLng: values => dispatch(saveLatLng(values)),
      handleCloseDrawer: () => dispatch(updateActiveCanvasDrawer()),
    }),
  ),
  withProductCustomisation,
  withQueryParams,
  withHandlers({
    onAbandonMap: props => () => {
      props.setSubmitting(false);
      props.saveLatLng({});
      props.setAddressListIndex(null);
      props.updateQueryParams({
        lat: null,
        lng: null,
      });
    },
    onMapMove: props => values => props.saveLatLng(values),
    onSave: props => (lat, lng) => {
      const values = { lat, lng };
      props.saveLatLng(values);
      props.updateProductCustomisation(values);
      props.updateQueryParams(values);
      props.handleCloseDrawer();
    },
  }),
);

export default enhance(BingMap);
